/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gift_Option_50_TitleInputs */

const es_gift_option_50_title = /** @type {(inputs: Gift_Option_50_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grumete de Agua Dulce`)
};

const gl_gift_option_50_title = /** @type {(inputs: Gift_Option_50_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grumete de Auga Doce`)
};

const en_gift_option_50_title = /** @type {(inputs: Gift_Option_50_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Freshwater Deckhand`)
};

/**
* | output |
* | --- |
* | "Freshwater Deckhand" |
*
* @param {Gift_Option_50_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const gift_option_50_title = /** @type {((inputs?: Gift_Option_50_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gift_Option_50_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_gift_option_50_title(inputs)
	if (locale === "en") return en_gift_option_50_title(inputs)
	return es_gift_option_50_title(inputs)
});